import { Button, Space } from 'antd';
// import { MenuOutlined } from '@ant-design/icons';
import styles from './style.module.scss';
// import { ReactComponent as BlackLogo } from '../../../assets/svg/ingame-logo-black.svg';
// import { ReactComponent as NewLogo } from '../../../assets/svg/ingame-logo-new.svg';
import { ReactComponent as NewLogo } from '../../../assets/svg/ingame-logo-n.svg';
import { ReactComponent as NewLogoLight } from '../../../assets/svg/ingame-logo-n-light.svg';
// import { ReactComponent as IconEarth } from '../../../assets/svg/earth.svg';
// import { ReactComponent as IconUser } from '../../../assets/svg/user.svg';
import classNames from 'classnames';
import { useState } from 'react';
import getFormatMessage from '../../../locales/get-format-message';
import { ItemSiteSwitchComponent } from './item-stie-switch';
import { getConfig } from '../../../config';
import { getLocaleLanguage, isDark, LanguageType } from '../../../lib';
import { UserAccountComponent } from './user-account';
import { getLoginToken } from '../../lib';
import { jumpLogin } from '../../../lib/jump-website';
import { ProductsHoverComponent } from './products-hover';

interface IProps {
  readonly expand?: boolean;
  readonly scrollPosition?: 'bottom' | 'top' | '';
}

export const HeaderComponent = (props: IProps) => {
  const consoleURL = getConfig()?.consoleURL;
  const userURL = getConfig()?.userURL;
  const documentConfig = getConfig()?.documentConfig;
  const ingameModule = documentConfig.modules.find(
    (module) => module.key === 'INGAME'
  );
  const currentStoreLanguage = getLocaleLanguage() || LanguageType.en_US;
  const ticket = getLoginToken();
  const handleDocumentationClick = () => {
    const pid = ingameModule?.pid[currentStoreLanguage];
    const url = consoleURL && pid ? `${consoleURL}/doc/detail/${pid}` : '';
    // if (ticket) {
    // if (url) {
    window.open(url, '_blank');
    // }
    // } else {
    //   jumpLogin(url);
    // }
  };
  const handleDownloadCenterClick = () => {
    const url = consoleURL
      ? new URL(`https://${consoleURL}/download/download-center`)
      : undefined;
    if (ticket && consoleURL) {
      url?.searchParams.append('ingame_language', currentStoreLanguage);
      window.open(url?.toString(), '_blank');
    } else {
      jumpLogin(url?.toString());
    }
  };
  const handleToConsoleClick = () => {
    if (ticket && consoleURL) {
      const url = new URL(`https://${consoleURL}`);
      url.searchParams.append('ingame_language', currentStoreLanguage);
      window.open(url.toString(), '_blank');
    } else {
      jumpLogin();
    }
  };

  // 移动端导航相关
  const [showNavMore, setShowNavMore] = useState<boolean>(false);
  const updateSetting = () => {
    setShowNavMore(!showNavMore);
  };
  const [curNavId, setCurNavId] = useState<string>(location.pathname);
  const updateNav = (path: string) => {
    setCurNavId(path);
  };

  return (
    <div
      className={classNames(
        styles.headerNav,
        props.expand && styles.isScrollDown,
        props.scrollPosition !== 'top' && props.expand && styles.hasShadow,
        isDark() ? styles.darkHeader : '',
        `header-menu`
      )}
    >
      <div
        className={classNames(
          styles.navSetting,
          showNavMore && styles.showNavMore
        )}
        onClick={updateSetting}
      ></div>
      {/* 移动端导航，pc下不显示 */}
      {showNavMore && (
        <div
          className={classNames(styles.navMainItem, styles.navMainItemMobile)}
        >
          <div className={styles.navBgMask}></div>
          <ul className={styles.navMainListBox}>
            <li
              className={classNames(
                styles.navMainListLi,
                styles.productsBox,
                (curNavId === '/' || curNavId.includes('/products')) &&
                  styles.curNav
              )}
              onClick={() => updateNav('/')}
            >
              <a
                className={
                  location.pathname.includes('/products') ? 'active' : ''
                }
              >
                <span>{getFormatMessage('products_home')}</span>
                <div className={styles.downIcon}></div>
              </a>
            </li>
            <li
              className={classNames(
                styles.navMainListLi,
                curNavId === '/get-started' && styles.curNav
              )}
              onClick={() => updateNav('/get-started')}
            >
              <a
                href="/get-started"
                className={location.pathname === '/get-started' ? 'active' : ''}
              >
                {getFormatMessage('get_started_uppercase')}
              </a>
            </li>
            {/* <li className={styles.navMainListLi}>
            <a
              onClick={handleDocumentationClick}
              className={location.pathname === '/documentation' ? 'active' : ''}
            >
              {getFormatMessage('documentation')}
            </a>
          </li> */}
            <li
              className={classNames(
                styles.navMainListLi,
                curNavId === '/download-center' && styles.curNav
              )}
              // onClick={() => updateNav('/download-center')}
            >
              <a
                onClick={handleDownloadCenterClick}
                className={
                  location.pathname === '/download-center' ? 'active' : ''
                }
              >
                {getFormatMessage('download_center')}
              </a>
            </li>
            <li
              className={classNames(
                styles.navMainListLi,
                styles.resourcesBox,
                (curNavId === '/resources' || curNavId === '/roadmap') &&
                  styles.curNav
              )}
              onClick={() => updateNav('/resources')}
            >
              <a
              // onClick={handleDownloadCenterClick}
              // className={
              //   location.pathname === '/download-center' ? 'active' : ''
              // }
              >
                <span>{getFormatMessage('resources')}</span>
                <div className={styles.downIcon}></div>
              </a>
            </li>
            {/* <li className={styles.navMainListLi}>
            <a href="">{getFormatMessage('about_us')}</a>
          </li> */}
          </ul>
          <div className={styles.navMainListSubBox}>
            {(curNavId === '/' || curNavId.includes('/products')) && (
              <ProductsHoverComponent onClose={updateSetting} />
            )}
            {(curNavId === '/resources' || curNavId === '/roadmap') && (
              <div className={styles.resourcesHoverBox}>
                <a
                  className={classNames(
                    styles.resourcesHoverItem,
                    location.pathname === '/documentation'
                      ? styles.resourcesHoverActive
                      : ''
                  )}
                  onClick={handleDocumentationClick}
                >
                  {getFormatMessage('documentation')}
                </a>
                <a
                  href="/roadmap"
                  className={classNames(
                    styles.resourcesHoverItem,
                    location.pathname === '/roadmap'
                      ? styles.resourcesHoverActive
                      : ''
                  )}
                >
                  Roadmap
                </a>
              </div>
            )}
          </div>
        </div>
      )}

      <div className={styles.navLogoItem}>
        <a href="/">
          {isDark() ? (
            <NewLogo style={{ width: '100%', height: '100%' }} />
          ) : (
            <NewLogoLight style={{ width: '100%', height: '100%' }} />
          )}
        </a>
      </div>
      <div className={styles.mainContentSapce}></div>
      <div className={styles.navMainItem}>
        {/* <div className={styles.navMoreIcon}>
          <MenuOutlined />
        </div> */}
        <ul className={styles.navMainListBox}>
          <li className={classNames(styles.navMainListLi, styles.productsBox)}>
            <a
              className={
                location.pathname.includes('/products') ? 'active' : ''
              }
            >
              <span>{getFormatMessage('products_home')}</span>
              <div className={styles.downIcon}></div>
            </a>
            <ProductsHoverComponent onClose={updateSetting} />
          </li>
          <li className={styles.navMainListLi}>
            <a
              href="/get-started"
              className={location.pathname === '/get-started' ? 'active' : ''}
            >
              {getFormatMessage('get_started_uppercase')}
            </a>
          </li>
          {/* <li className={styles.navMainListLi}>
            <a
              onClick={handleDocumentationClick}
              className={location.pathname === '/documentation' ? 'active' : ''}
            >
              {getFormatMessage('documentation')}
            </a>
          </li> */}
          <li className={styles.navMainListLi}>
            <a
              onClick={handleDownloadCenterClick}
              className={
                location.pathname === '/download-center' ? 'active' : ''
              }
            >
              {getFormatMessage('download_center')}
            </a>
          </li>
          <li className={classNames(styles.navMainListLi, styles.resourcesBox)}>
            <a
            // onClick={handleDownloadCenterClick}
            // className={
            //   location.pathname === '/download-center' ? 'active' : ''
            // }
            >
              <span>{getFormatMessage('resources')}</span>
              <div className={styles.downIcon}></div>
            </a>
            <div className={styles.resourcesHoverBox}>
              <a
                className={classNames(
                  styles.resourcesHoverItem,
                  location.pathname === '/documentation'
                    ? styles.resourcesHoverActive
                    : ''
                )}
                onClick={handleDocumentationClick}
              >
                {getFormatMessage('documentation')}
              </a>
              <a
                href="/roadmap"
                className={classNames(
                  styles.resourcesHoverItem,
                  location.pathname === '/roadmap'
                    ? styles.resourcesHoverActive
                    : ''
                )}
              >
                Roadmap
              </a>
            </div>
          </li>
          {/* <li className={styles.navMainListLi}>
            <a href="">{getFormatMessage('about_us')}</a>
          </li> */}
        </ul>
      </div>
      <div className={styles.navSideItem}>
        <Space size={32}>
          <ul className={styles.navMainListRightBox}>
            <ItemSiteSwitchComponent />
          </ul>
          <UserAccountComponent
            consoleURL={consoleURL}
            userURL={userURL}
            handleDownloadCenterClick={handleDownloadCenterClick}
          />
          {/* <div className={styles.navUser} onClick={onHandleLogin}>
            <IconUser width={16} height={16} />
          </div> */}
          {
            <div className={styles.devPortalBtn} onClick={handleToConsoleClick}>
              {getFormatMessage('dev_portal')}
            </div>
          }
          {/* <div className={styles.devPortalBtn} onClick={handleToConsoleClick}>
            {getFormatMessage('dev_portal')}
          </div> */}
        </Space>
      </div>
    </div>
  );
};
